<template>
  <div :class="mainClasses">
    <div class="IO__container">
      <div class="IO__title">{{ title }}</div>
      <div class="IO__input">
        <div class="IO__input-hole"></div>
      </div>
    </div>
    <div class="IO__tap" @click="handleClick"></div>
  </div>
</template>

<script>
import EventBus from '@/components/EventBus.js';

export default {
  name: 'IO',
  props: {
    title: String,
    code: String,
    active: Boolean,
    color: String,
    output: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false
    }
  },
  computed: {
    mainClasses() {
      const classes = {
        IO: true,
        IO_active: this.active,
        IO_output: this.output
      }
      classes[`IO_color_${this.color}`] = true
      return classes;
    }
  },
  methods: {
    handleClick() {
      EventBus.$emit('io-click', this.code)
    }
  }
}
</script>

<style lang="scss">
.IO {
  height: 72px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  padding: 1px 4px 3px;

  @keyframes active-pulse {
    0% {
      background: rgba(0, 0, 0, 0.1);
    }

    50% {
      background: rgba(0, 0, 0, 0.16);
    }

    100% {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  &_active &__tap {
    background: rgba(0, 0, 0, 0.1);
    animation: active-pulse 1s ease-in-out infinite;
  }

  &_active &__title {
    color: white;
  }

  &_active &__input {
    border-color: white;

    &-hole {
      background: white;
    }
  }

  &_output &__container {
    // background: black;
    border: 1px solid rgba(0, 0, 0, 0.25);
  }

  // &_output &__title {
  //   color: white;
  // }
  // //
  // &_output &__input {
  //   border-color: white;
  //   border-width: 2px;
  // }
  //
  // &_output &__input-hole {
  //   background: black;
  //   border: 3px solid white;
  //   position: relative;
  //   left: -1px;
  //   top: -1px;
  // }
  //
  // &_output.IO_color_orange &__input,
  // &_output.IO_color_orange &__input-hole {
  //   border-color: #FA6400;
  // }
  //
  // &_output.IO_color_green &__input,
  // &_output.IO_color_green &__input-hole {
  //   border-color: #89CA73;
  // }
  //
  // &_output.IO_color_red &__input,
  // &_output.IO_color_red &__input-hole {
  //   border-color: #DA4745;
  // }
  //
  // &_output.IO_color_yellow &__input,
  // &_output.IO_color_yellow &__input-hole {
  //   border-color: #FBC805;
  // }
  //
  // &_output.IO_color_cyan &__input,
  // &_output.IO_color_cyan &__input-hole {
  //   border-color: #96D0DC;
  // }
  //
  // &_output.IO_color_coral &__input,
  // &_output.IO_color_coral &__input-hole {
  //   border-color: #FA7E57;
  // }
  //
  // &_output.IO_color_violet &__input,
  // &_output.IO_color_violet &__input-hole {
  //   border-color: #B620E0;
  // }

  &__container {
    border-radius: 8px;
    border: 1px solid transparent;
    height: 66px;
    padding: 6px 0;
    box-sizing: border-box;
  }

  &__title {
    text-align: center;
    font-size: 12px;
    line-height: 12px;
  }

  &__input {
    padding: 4px;
    border: 4px solid black;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    margin: 4px auto 0;
    box-sizing: border-box;

    &-hole {
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background: black;
    }
  }

  &__tap {
    position: absolute;
    top: 1px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    border-radius: 8px;
    z-index: 10;
    cursor: pointer;
  }
}
</style>
